// src/pages/processifyd/ProcessifydGroups.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faFolderOpen,
  faSearch,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faList,
} from "@fortawesome/free-solid-svg-icons";

const ProcessifydGroups = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const [showModal, setShowModal] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const [loading, setLoading] = useState(false);

  const initialForm = {
    groupCategory: "",
    groupType: "",
    groupName: "",
    groupDetails: "",
    clientName: "",                    // clientName reference (e.g. 21st Century Financial Services)
    active: "Yes",
  };

  const [formData, setFormData] = useState(initialForm);

  // Sample Demo Data
  const demoGroups = [
    {
      id: 1,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "Survey Lead",
      groupDetails: "Owner of survey lifecycle including creation, scheduling, and overall execution.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:20",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:20",
    },
    {
      id: 2,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "NPS Team",
      groupDetails: "Responsible for Net Promoter Score tracking, analysis, and improvement initiatives.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:21",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:21",
    },
    {
      id: 3,
      groupCategory: "RACI Group",
      groupType: "Consultants",
      groupName: "Analyst Team",
      groupDetails: "Handles data analysis, reporting, insights generation, and trend identification.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:22",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:22",
    },
    {
      id: 4,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "CAPA Team",
      groupDetails: "Manages Corrective and Preventive Actions based on feedback and analysis.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:23",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:23",
    },
    {
      id: 5,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "Compliance Team",
      groupDetails: "Ensures all processes adhere to regulatory, legal, and internal compliance standards.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:24",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:24",
    },
    {
      id: 6,
      groupCategory: "RACI Group",
      groupType: "Management",
      groupName: "Management Team",
      groupDetails: "Provides strategic direction, approvals, and decision-making authority.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:25",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:25",
    },
    {
      id: 7,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "Program Team",
      groupDetails: "Coordinates program execution, timelines, stakeholder communication, and delivery tracking.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:26",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:26",
    },
    {
      id: 8,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "Data Team",
      groupDetails: "Handles data collection, storage, validation, and integration across systems.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:27",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:27",
    },
    {
      id: 9,
      groupCategory: "RACI Group",
      groupType: "Consultants",
      groupName: "SMEs (Subject Matter Experts)",
      groupDetails: "Provides domain expertise, validation, and guidance on process and business logic.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:28",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:28",
    },
    {
      id: 10,
      groupCategory: "RACI Group",
      groupType: "Client",
      groupName: "Stakeholder",
      groupDetails: "Business stakeholders impacted by outcomes; involved in feedback and approvals.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:29",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:29",
    },
    {
      id: 11,
      groupCategory: "RACI Group",
      groupType: "Employee",
      groupName: "Relevant Teams",
      groupDetails: "Other supporting teams involved based on process needs and cross-functional dependencies.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "Sanjeev Kumar",
      createdDate: "18/03/26 13:30",
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: "18/03/26 13:30",
    },

    // ✅ Process Groups (NEW)
    {
      id: 12,
      groupCategory: "Process Group",
      groupType: "Process",
      groupName: "Loan Origination",
      groupDetails: "Covers lead generation, application intake, and initial validation.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "System",
      createdDate: "18/03/26 14:00",
      lastUpdatedBy: "System",
      lastUpdateDate: "18/03/26 14:00",
    },
    {
      id: 13,
      groupCategory: "Process Group",
      groupType: "Process",
      groupName: "Loan Closure",
      groupDetails: "Includes disbursement, documentation closure, and customer confirmation.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "System",
      createdDate: "18/03/26 14:02",
      lastUpdatedBy: "System",
      lastUpdateDate: "18/03/26 14:02",
    },
    {
      id: 14,
      groupCategory: "State Group",
      groupType: "Workflow",
      groupName: "Initiated",
      groupDetails: "Process has been started but not yet validated.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "System",
      createdDate: "18/03/26 14:05",
      lastUpdatedBy: "System",
      lastUpdateDate: "18/03/26 14:05",
    },
    {
      id: 15,
      groupCategory: "State Group",
      groupType: "Workflow",
      groupName: "Completed",
      groupDetails: "Process successfully completed and closed.",
      clientName: "21st Century Financial Services",
      active: "Yes",
      createdBy: "System",
      createdDate: "18/03/26 14:06",
      lastUpdatedBy: "System",
      lastUpdateDate: "18/03/26 14:06",
    },
  ];

  const loadSample = () => {
    setGroups(demoGroups);
  };

  const handleAddNew = () => {
    setEditingGroup(null);
    setFormData(initialForm);
    setShowModal(true);
  };

  const handleEdit = (group) => {
    setEditingGroup(group);
    setFormData({
      groupCategory: group.groupCategory || "",
      groupType: group.groupType || "",
      groupName: group.groupName || "",
      groupDetails: group.groupDetails || "",
      clientName: group.clientName || "",
      active: group.active || "Yes",
    });
    setShowModal(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this group? This action cannot be undone.")) return;
    setGroups((prev) => prev.filter((g) => g.id !== id));
  };

  const handleOpenGroup = (group) => {
    // Update this route as per your actual group detail page
    navigate(`/processifyd-grouphub/${group.id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.groupType.trim() || !formData.groupName.trim() || !formData.clientName.trim()) {
      alert("Group Name, Group Value, and clientName are required.");
      return;
    }

    const newGroup = {
      id: editingGroup?.id || Date.now(),
      ...formData,
      createdBy: editingGroup?.createdBy || "Sanjeev Kumar",
      createdDate: editingGroup?.createdDate || new Date().toLocaleString("en-IN"),
      lastUpdatedBy: "Sanjeev Kumar",
      lastUpdateDate: new Date().toLocaleString("en-IN"),
    };

    if (editingGroup) {
      setGroups((prev) =>
        prev.map((g) => (g.id === editingGroup.id ? newGroup : g))
      );
    } else {
      setGroups((prev) => [...prev, newGroup]);
    }

    setShowModal(false);
    setFormData(initialForm);
  };

  // Filter + Pagination
  const filtered = groups.filter(
    (g) =>
      g.groupCategory.toLowerCase().includes(search.toLowerCase()) ||
      g.groupType.toLowerCase().includes(search.toLowerCase()) ||
      g.groupName.toLowerCase().includes(search.toLowerCase()) ||
      g.clientName.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );

  const [showList, setShowList] = useState(false);
    
  const handleShowMyGroups = async () => {
    try {
      setLoading(true);

      // 🔄 Replace this later with API call
      // const response = await axios.get("/api/racigroups");
      // setGroups(response.data);

      // ✅ Temporary Demo Data (remove later)
      setGroups([]);

      setShowList(true);
    } catch (error) {
      console.error("Error fetching Groups:", error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-6">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            👥 Processifyd
          </div>
          <div className="text-xs text-gray-400">
            Groups Master Management
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 hover:bg-teal-900/30 rounded-md"
            >
              🔐
            </button>
          )}
        </div>

        <button
          className="md:hidden text-2xl text-cyan-300"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-4">
          {isLoggedIn && (
            <div className="flex flex-col items-center gap-4">
              <div className="text-teal-300">{userName}</div>
              <button onClick={handleLogout} className="w-12 px-2 py-1 bg-red-700 rounded-md">⏻</button>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh]">
        {/* Controls */}
        <div className="mt-4 flex flex-col lg:flex-row gap-4">
          <div className="flex flex-row gap-3">
            <button
              onClick={loadSample}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-48 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              Load Sample Groups
            </button>
            <button
              onClick={handleShowMyGroups}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-40 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faList} />
              My Groups List
            </button>
            <button
              onClick={handleAddNew}
              className="flex items-center justify-center gap-2 text-xs lg:text-sm w-40 lg:w-32 px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
            >
              <FontAwesomeIcon icon={faPlus} />
              New Group
            </button>
          </div>

          <div className="relative w-full">
            <FontAwesomeIcon
              icon={faSearch}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
            />
            <input
              type="text"
              placeholder="Search by group type, name, details or clientName..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-cyan-500/60"
            />
          </div>
        </div>

        {/* Groups Cards */}
        <div className="mt-4 grid gap-4 grid-cols-1 lg:grid-cols-3 xl:grid-cols-4">
          {paginated.map((group) => (
            <div
              key={group.id}
              className="bg-gray-800 border border-gray-700 rounded-xl p-5 hover:border-cyan-600/50 transition-colors group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors">
                    {group.groupCategory}
                  </h3>
                  <h3 className="font-semibold text-base text-white group-hover:text-cyan-300 transition-colors">
                    {group.groupType} : {group.groupName}
                  </h3>
                  <div className="text-sm text-gray-400 mt-1">
                    Client Name: <span className="text-cyan-300">{group.clientName}</span>
                  </div>
                </div>

                <div className="flex flex-col items-end gap-1">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${group.active === "Yes" ? "bg-emerald-600" : "bg-red-600"}`}>
                    {group.active === "Yes" ? "Active" : "Inactive"}
                  </span>
                </div>
              </div>

              <div className="mt-6 flex gap-2">
                <button
                  onClick={() => handleOpenGroup(group)}
                  className="flex-1 py-2 bg-gradient-to-r from-cyan-700 to-teal-700 hover:from-cyan-600 hover:to-teal-600 rounded-lg font-medium flex items-center justify-center gap-2 text-sm"
                >
                  <FontAwesomeIcon icon={faFolderOpen} />
                  Open
                </button>

                <button
                  onClick={() => handleEdit(group)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Edit Group"
                >
                  <FontAwesomeIcon icon={faEdit} className="text-yellow-400" />
                </button>

                <button
                  onClick={() => handleDelete(group.id)}
                  className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  title="Delete Group"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-400" />
                </button>
              </div>
            </div>
          ))}

          {paginated.length === 0 && (
            <div className="col-span-full py-12 text-center text-gray-500">
              {search ? "No groups match your search" : "No groups yet. Click 'New Group' or 'Load Sample Groups'"}
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-10">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="text-sm">
              Page <strong>{currentPage}</strong> of {totalPages}
            </span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="w-10 px-2 py-2 bg-gray-800 border border-gray-700 rounded-lg disabled:opacity-50"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        )}

        {showList && (
          <div className="mt-4 bg-black text-white rounded-lg p-4">
            {loading ? (
              <p className="text-yellow-200">Loading Groups...</p>
            ) : groups.length === 0 ? (
              <p className="text-yellow-200">No Groups found.</p>
            ) : (
              <ul className="space-y-2">
                {groups.map((grp) => (
                  <li
                    key={grp.id}
                    className="border border-gray-700 rounded p-2"
                  >
                    <p className="font-semibold text-gray-100">{grp.groupType}</p>
                    <p className="font-semibold text-gray-100">{grp.groupName}</p>
                    <p className="font-semibold text-gray-100">{grp.groupCategory}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Add / Edit Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-6 w-full max-w-lg border border-gray-700 max-h-[92vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                  {editingGroup ? "Edit Group" : "New Group"}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-white w-12 text-2xl"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm mb-1.5">Group Category <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.groupCategory}
                    onChange={(e) => setFormData({ ...formData, groupCategory: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. Process, State, RACI, Others etc."
                  />
                </div>
                <div>
                  <label className="block text-sm mb-1.5">Group Type <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.groupType}
                    onChange={(e) => setFormData({ ...formData, groupType: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. Employee, Branch, Department, Region, etc."
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Group Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.groupName}
                    onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. BKC 1, Andheri East"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Group Details <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.groupDetails}
                    onChange={(e) => setFormData({ ...formData, groupDetails: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. This group is for RACI team"
                  />
                </div>

                <div>
                  <label className="block text-sm mb-1.5">Client Name <span className="text-red-400">*</span></label>
                  <input
                    required
                    value={formData.clientName}
                    onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
                    className="w-full px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:border-cyan-500"
                    placeholder="e.g. 21st Century Financial Services"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm mb-1.5">Active <span className="text-red-400">*</span></label>
                    <select
                      value={formData.active}
                      onChange={(e) => setFormData({ ...formData, active: e.target.value })}
                      className="w-full h-12 px-4 py-2.5 bg-gray-700 border border-gray-600 rounded-lg"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-2 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium"
                  >
                    {editingGroup ? "Update Group" : "Create Group"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-8">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <a href="/about-us" className="hover:text-teal-300">About</a>
            <a href="/privacy-policy" className="hover:text-teal-300">Privacy Policy</a>
            <a href="/terms-of-use" className="hover:text-teal-300">Terms of Use</a>
            <a href="/contact-us" className="hover:text-teal-300">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydGroups;